const clearLocalStorage = () => {
	localStorage.clear();
};

export default clearLocalStorage;
